import React from "react";
import {
  MainNavigationContainer,
  MainNavigationContent,
  NavBarCenterContainer,
  NavBarLeftContainer,
  NavigationLinks
} from "../style";
import Logo from "components/site/logo";
import NavigationItem from "./NavigationItem";
import type { AppTheme } from "themes/global";
import type { NavLinkProps } from "../navigation-links";
import { useNavigation } from "../NavigationContext";

interface NavigationContainerProps {
  theme: AppTheme;
  hideNavigationLinks: boolean;
  hidePathNavigationLinks: boolean;
  isGoogleSearchPage: boolean;
  navigationLinks: NavLinkProps[];
  rightItems: React.ReactNode;
}

const NavigationContainer = ({
  theme,
  hideNavigationLinks,
  hidePathNavigationLinks,
  isGoogleSearchPage,
  navigationLinks,
  rightItems
}: NavigationContainerProps) => {
  const { setActiveMenu } = useNavigation();
  return (
    <MainNavigationContainer className="large-desktop:px-0 px-6" theme={theme}>
      <NavBarLeftContainer>
        <Logo
          src={
            isGoogleSearchPage &&
            "/static/images/gemini-hor-light-full-white-rgb@3x.png"
          }
          theme={theme}
          onMouseEnter={() => setActiveMenu(null)}
        />
      </NavBarLeftContainer>
      {!hideNavigationLinks && !hidePathNavigationLinks && (
        <NavBarCenterContainer>
          <MainNavigationContent>
            <NavigationLinks>
              {navigationLinks.map((item) => (
                <NavigationItem key={item.key} item={item} theme={theme} />
              ))}
            </NavigationLinks>
          </MainNavigationContent>
        </NavBarCenterContainer>
      )}
      <div
        className="flex flex-grow basis-0 items-center justify-end gap-1"
        onMouseEnter={() => setActiveMenu(null)}
      >
        {rightItems}
      </div>
    </MainNavigationContainer>
  );
};

export default NavigationContainer;
